export default "__VITE_ASSET__CXLP$oXM__"